module.exports = __webpack_public_path__ + "img/668af75.png";